export enum Units {
    None = "None",
    Meters = "Meters"
}